import RoomTable from './RoomTable';
export default RoomTable;
